import { forwardRef } from "react";
import { PassThroughPropsWithRef } from "../../types";
import cx from "classnames";
import styles from "./DrillDown.module.scss";

/**
 * Props for the DrillDownFooter component.
 *
 * @extends PassThroughPropsWithRef<"footer">
 */
export type DrillDownFooterProps = PassThroughPropsWithRef<"footer"> & {};

/**
 * Footer section for DrillDown screens with action buttons.
 *
 * Provides a fixed bottom area for navigation buttons and actions. Typically contains
 * DrillDown.NextButton and DrillDown.PrevButton components.
 *
 * Features:
 * - Fixed positioning at bottom of drilldown screen
 * - Standard padding and layout for actions
 *
 * @example
 * ```tsx
 * <DrillDown.Footer>
 *   <Flex gap="3" justifyContent="flex-end">
 *     <DrillDown.PrevButton>Back</DrillDown.PrevButton>
 *     <DrillDown.NextButton appearance="primary">Continue</DrillDown.NextButton>
 *   </Flex>
 * </DrillDown.Footer>
 * ```
 */
export const DrillDownFooter = forwardRef<HTMLDivElement, DrillDownFooterProps>(
  (props, ref) => {
    const { className, ...rest } = props;

    return (
      <div
        {...rest}
        className={cx(styles["footer"], className)}
        ref={ref}
      ></div>
    );
  },
);

DrillDownFooter.displayName = "DrillDownFooter";
